import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import Switch from "components/Switch";
import IconWithTooltip from "components/IconWithTooltip";
import { ReactComponent as InfoIcon } from "icons/info-grey.svg";

const TwoOptionsRow = ({
  option1,
  option2,
  state,
  tooltipText,
  disabled,
  setState,
}) => {
  const handleChange = () => {
    setState(!state);
  };

  return (
    <div
      className={clsx("two_options_row", { disabled })}
      data-testid="two-options-row"
    >
      <span className={clsx({ active: !state, inactive: state })}>
        {option1}
      </span>
      <Switch
        id="two-options-row-switch"
        currentSwitchState={state}
        disabled={disabled}
        handleChange={handleChange}
      />
      <span className={clsx({ active: state, inactive: !state })}>
        {option2}
      </span>
      {tooltipText && (
        <IconWithTooltip
          icon={<InfoIcon width={11} height={11} />}
          tooltipText={tooltipText}
        />
      )}
    </div>
  );
};

TwoOptionsRow.propTypes = {
  option1: PropTypes.string.isRequired,
  option2: PropTypes.string.isRequired,
  state: PropTypes.bool.isRequired,
  tooltipText: PropTypes.string,
  disabled: PropTypes.bool,
  setState: PropTypes.func.isRequired,
};

TwoOptionsRow.defaultProps = {
  disabled: false,
  tooltipText: "",
};

export default TwoOptionsRow;
